// extracted by mini-css-extract-plugin
export default {"content":"transfer-owner_content__QM0OL","buttons":"transfer-owner_buttons__JfyIq"};